<script setup lang="ts">

import SignupsMetricTile from "@/components/Metrics/SignupsMetricTile.vue";
import ReturningUsersMetricTile from "@/components/Metrics/ReturningUsersMetricTile.vue";
import ReportPeriodFilterBar from "@/components/Reporting/ReportPeriodFilterBar.vue";
import UserHasSelectedSchoolSubjects from "@/components/Metrics/UserHasSelectedSchoolSubjectsMetricTile.vue";
import UserLoginsMetricTile from "@/components/Metrics/UserLoginsMetricTile.vue";
import HollandCodeCompletionRatioMetricTile from "@/components/Metrics/HollandCodeCompletionRatioMetricTile.vue";
import NewAccountsSignupTypesTile from "@/components/Metrics/NewAccountsSignupTypesTile.vue";
import Big5CompletionRatioMetricTile from "@/components/Metrics/Big5CompletionRatioMetricTile.vue";
import AccessCodesUsageRatioMetricTile from "@/components/Metrics/AccessCodesUsageRatioMetricTile.vue";
import {provide, ref, Ref} from "vue";
import {
  CohortFilterKey,
  DateFilterKey,
  DateFilterUnitKey, DateFilterValueKey,
  InstitutionFilterKey,
  TenantFilterKey
} from "@/symbols/metrics";
import {Entity, Role} from "@YenzaCT/sdk";
import {useGlobalStore} from "@/store";
import RecentSignupsTile from "@/components/Metrics/RecentSignupsTile.vue";
import {useReportingStore} from "@/store/reporting";

const store = useGlobalStore();
const reportingStore = useReportingStore();

const dateFilter: Ref<string> = ref("in the last");
const dateFilterUnit: Ref<string> = ref("days");
const dateFilterValue: Ref<string | string[]> = ref("7");
const tenantFilter: Ref<undefined> = ref(undefined);
const institutionFilter: Ref<undefined> = ref(undefined);
const cohortFilter: Ref<undefined> = ref(undefined);
provide(TenantFilterKey, tenantFilter);
provide(InstitutionFilterKey, institutionFilter);
provide(CohortFilterKey, cohortFilter);
provide(DateFilterKey, dateFilter);
provide(DateFilterUnitKey, dateFilterUnit);
provide(DateFilterValueKey, dateFilterValue);

const isAdminOrRoot = ref(store.user?.app.role === Role.Admin || store.user?.app.role === Role.Root);
const canReadVouchersTenant = ref(store.canReadEntity(Entity.Tenant, Entity.AccessCode));
const canReadVouchersInstitution = ref(store.canReadEntity(Entity.Institution, Entity.AccessCode));
const canReadVouchersCohort = ref(store.canReadEntity(Entity.Cohort, Entity.AccessCode));
</script>

<template>
  <v-row>
    <v-col cols="12">
      <ReportPeriodFilterBar
        :show-filters="true"
        @run-report="reportingStore.activateAndRefresh"
        @reset-filters="reportingStore.resetState"
      />
    </v-col>
  </v-row>

  <v-row v-show="reportingStore.active">
    <v-col cols="9">
      <v-row>
        <v-col cols="12">
          <NewAccountsSignupTypesTile/>
        </v-col>
        <v-col v-if="canReadVouchersTenant || canReadVouchersInstitution || canReadVouchersCohort || isAdminOrRoot"
               cols="4">
          <AccessCodesUsageRatioMetricTile/>
        </v-col>
        <v-col cols="4">
          <SignupsMetricTile/>
        </v-col>
        <v-col cols="4">
          <UserLoginsMetricTile/>
        </v-col>
        <v-col cols="4">
          <ReturningUsersMetricTile/>
        </v-col>
        <v-col cols="4">
          <UserHasSelectedSchoolSubjects/>
        </v-col>
        <v-col cols="4">
          <HollandCodeCompletionRatioMetricTile/>
        </v-col>
        <v-col cols="4">
          <Big5CompletionRatioMetricTile/>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="3">
      <RecentSignupsTile/>
    </v-col>
  </v-row>
  <v-row v-if="!reportingStore.active">
    <v-col class="text-center text-gray mt-6">
      <h1>Please select a tenant, institution or cohort to see usage metrics.</h1>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
